import { createFileRoute, Outlet } from "@tanstack/react-router";
import ProcurePage from "lib/components/procure/layout/ProcurePage";

function EstimateLayout() {
  return (
    <ProcurePage title="Estimate">
      <Outlet />
    </ProcurePage>
  );
}

export const Route = createFileRoute("/builders/$builder_id/estimate")({
  component: EstimateLayout,
});
